import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ValueAdditionFiveDto } from "./addition-type-five.dto";

export class AllvalueAdditionFiveResponse extends GlobalResponseObject{

      data?: ValueAdditionFiveDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ValueAdditionFiveDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}